import React from 'react'
import Heading from './Heading'
import DatePickers from './DatePicker'
import { Grid } from '@mui/material'
import FullName from './FullName'
import Email from './Email'
import Number from './Number'
import LongText from './LongText'

const OvertimeRequestForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم درخواست اضافه کاری'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <DatePickers header={'تاریخ امروز:'}/>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'ایمیل'} />
                <FullName header={'مدیر شما: نام'}/>
                <DatePickers header={'تاریخ اضافه کاری:'}/>
                <Number header={'تعداد ساعات اضافه کاری درخواستی:'}/>
                <LongText header={'دلیل اضافه کاری'}/>
                <LongText header={'شرح کامل درخواست:'}/>
            </Grid>
        </Grid>
    )
}

export default OvertimeRequestForm
